import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {Link, Navigate} from "react-router-dom";
//import { jsx } from "@emotion/core";
import {FieldAttributes, Form, Formik, useField} from "formik";
import * as Yup from "yup";
import classNames from "classnames";
import {ErrorM} from "components/helpers";
import {
  selectAuthMessage,
  selectAuthStatus,
  signIn,
  SignInAttempt,
  checkIdp } from "reducers/auth";
import "./SignIn.css";
import Button from "components/ui/Button";
import Logo_Dark from "../../assets/Logo_Dark.png";
import {Spinner} from "components/ui/Spinner";
import {BASE_URL} from "../../config";

function FieldInput<T>(props: FieldAttributes<T> & { label: string }) {
  const {label, ...fieldProps} = props;
  const [field, meta] = useField(fieldProps as FieldAttributes<T>);
  const showError = meta.touched && meta.error;
  const {className: existingClasses, ...rest} = props;
  const className = classNames(existingClasses, {ErrorInput: showError});
  const labelClass = classNames("FormLabel", {ErrorInputLabel: showError});

  return (
    <div className="FormField">
      <label className={labelClass}>
        {label}
        <input {...(field as any)} {...rest} className={className} />
      </label>
      <ErrorM name={props.name} />
    </div>
  );
}

function RememberMeInput<T>(props: FieldAttributes<T>) {
  const [field] = useField(props);
  const { className, ...rest } = props;

  return <input {...(field as any)} {...rest} className={className} />;
}

const SignIn: React.FC = () => {
  const dispatch = useDispatch();
  const authStatus = useSelector(selectAuthStatus);
  const message = useSelector(selectAuthMessage);
  if (authStatus === "signed_in") {
    return <Navigate to={"/"}/>;
  }

  if (authStatus === "uses_idp" && message != "") {

    window.location.href = BASE_URL + message;

  }

  const handleSubmit = (values: SignInAttempt) => {
    dispatch(signIn(values));
  };



  const initialValues: SignInAttempt = {
    emailAddress: "",
    password: "",
    rememberMe: false,
  };

  const validationSchema = Yup.object({
    emailAddress: Yup.string()
      .required("An email address is required")
      .email("Must be a valid email address"),
    password: Yup.string().required("You must provide a password"),
    rememberMe: Yup.boolean(),
  });


  return (
    <div className="LoginTable">
      <div className="LoginCell">
        <div className="LoginForm">
          <div className="Logo">
            <img src={Logo_Dark} alt="Logo"/>
          </div>
          <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
          >
            {props => (
                <Form>
                  <div className="FormBox">
                    <FieldInput
                        label="Email Address"
                        id="emailAddress"
                        className="EditBox"
                        name="emailAddress"
                        disabled={authStatus !== "signed_out"}
                    />
                  </div>
                  <div style={{minHeight: "1em"}}>
                    {authStatus === "pending" && (
                        <Spinner positionFixed={false}/>
                    )}
                  </div>
                  {authStatus != "signed_out" && authStatus != "uses_idp"  &&

                      <div className="FormBox">
                        <FieldInput
                            label="Password"
                            id="password"
                            className="EditBox"
                            name="password"
                            type="password"
                        />
                        <br/>
                        <div className="SignInConfig">
                          <RememberMeInput
                              type="checkbox"
                              name="rememberMe"
                              id="rememberMe"
                              checked={props.values.rememberMe}
                          />
                          <label className="CustomInput" htmlFor="rememberMe">
                            Remember me
                          </label>
                          <Link to="/forgotten-password">
                          <span className="ForgottenPassword">
                            Forgotten Password?
                          </span>
                          </Link>
                        </div>

                        <Button
                            variety="full"
                            type="submit"
                            color="blue"
                            style={{fontSize: "15px"}}
                        >
                          Log in
                        </Button>
                      </div>
                  }


                </Form>

            )}
          </Formik>
          <div>
            {message === "Invalid" && (
                <p className="SignInErrorMessage">
                  Password or email address incorrect
                </p>
            )}
            {message === "TemporarilyLocked" && (
                <p className="SignInErrorMessage">
                  Locked: please try again in 10 minutes
                </p>
            )}
            {message !== null && authStatus != "uses_idp"  && (
                <p className="SignInErrorMessage">
                  {message}
                </p>
            )}
          </div>
          {authStatus == "signed_out" &&
              <Button
                  variety="full"
                  onClick={() => dispatch(checkIdp({emailAddress: (document.getElementById("emailAddress") as HTMLInputElement).value}))}
                  color="blue"
                  style={{fontSize: "15px"}}
              >
                Next
              </Button>
          }
        </div>
      </div>
    </div>
  );
};

export default SignIn;
